import { isAdminApp } from '~/public/lib/PageHelpers';

const InlineEditableItemContainer = ({ label, children, className = '' }) => (
    <div>
        {label && <div className="font-medium mb-2">{label}</div>}
        <div className={`text-gray-600 ${isAdminApp() ? 'border-dashed border border-[#dddddd] rounded-lg px-4 py-2' : ''} ${className}`}>
            {children}
        </div>
    </div>
);

export default InlineEditableItemContainer;

